"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _index = _interopRequireDefault(require("../index"));

var _validator = _interopRequireDefault(require("./validator"));

var _EventHandler = _interopRequireDefault(require("./EventHandler"));

var _RankedList = _interopRequireDefault(require("./RankedList"));

var _helpers = require("./helpers");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RankInput = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(RankInput, _Component);

  var _super = _createSuper(RankInput);

  function RankInput(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, RankInput);
    _this = _super.call(this, props);
    _this.rankedList = new _RankedList["default"]();
    return _this;
  }

  (0, _createClass2["default"])(RankInput, [{
    key: "renderOption",
    value: function renderOption(option, index) {
      var _classNames,
          _classNames2,
          _this2 = this;

      var _this$props = this.props,
          storedValue = _this$props.storedValue,
          isValid = _this$props.isValid,
          complete = _this$props.complete,
          fieldData = _this$props.fieldData,
          classPrefix = _this$props.classPrefix,
          eventHandler = _this$props.eventHandler;
      var isLastRanked = this.rankedList.find(option.value, 'order') === this.rankedList.values().length;
      var displayRank = this.rankedList.find(option.value, 'order') || this.rankedList.values().length + 1;
      var optionChecked = (0, _helpers.isChecked)(storedValue, option.value);
      var optionClass = (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(classPrefix, "__input-animation-").concat(index), true), (0, _defineProperty2["default"])(_classNames, "".concat(classPrefix, "__option"), !optionChecked), (0, _defineProperty2["default"])(_classNames, "".concat(classPrefix, "__option--active"), optionChecked && !isLastRanked), (0, _defineProperty2["default"])(_classNames, "".concat(classPrefix, "__option--last"), isLastRanked), _classNames));
      var numberClass = (0, _classnames["default"])((_classNames2 = {}, (0, _defineProperty2["default"])(_classNames2, "".concat(classPrefix, "__number"), !optionChecked), (0, _defineProperty2["default"])(_classNames2, "".concat(classPrefix, "__number--active"), optionChecked), _classNames2));
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: option.value,
        className: "".concat(optionClass)
      }, /*#__PURE__*/_react["default"].createElement("input", {
        className: "".concat(classPrefix, "__input"),
        id: option.value,
        name: fieldData.fieldKey,
        type: "checkbox",
        value: option.value,
        checked: optionChecked,
        onChange: function onChange(event) {
          eventHandler.onChange(event, _this2.rankedList, fieldData, isValid, complete);
        },
        onKeyPress: function onKeyPress(event) {
          eventHandler.onKeyPress(event, _this2.rankedList, fieldData, isValid, complete);
        }
      }), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: option.value,
        className: "".concat(classPrefix, "__label")
      }, option.label), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "__check")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(numberClass)
      }, displayRank)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          fieldData = _this$props2.fieldData,
          classPrefix = _this$props2.classPrefix,
          eventHandler = _this$props2.eventHandler;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "__wrapper")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "__question")
      }, fieldData.label), fieldData.instructions && /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "__instructions")
      }, fieldData.instructions), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "__options")
      }, fieldData.options.map(function (option, index) {
        return _this3.renderOption(option, index);
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "__history-row")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "__reset"),
        role: "button",
        type: "button",
        tabIndex: 0,
        onKeyPress: function onKeyPress(event) {
          return eventHandler.onKeyPressReset(event, _this3.rankedList);
        },
        onClick: function onClick(event) {
          return eventHandler.onClickReset(event, _this3.rankedList);
        }
      }, "Reset All Rank")));
    }
  }]);
  return RankInput;
}(_react.Component);

RankInput.displayName = 'RankInputControl';
RankInput.propTypes = {
  storedValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]).isRequired,
  isValid: _propTypes["default"].bool.isRequired,
  dirty: _propTypes["default"].bool.isRequired,
  // eslint-disable-line
  complete: _propTypes["default"].bool.isRequired,
  classPrefix: _propTypes["default"].string.isRequired,
  eventHandler: _propTypes["default"].shape({
    handleUpdate: _propTypes["default"].func,
    handleRedo: _propTypes["default"].func,
    onChange: _propTypes["default"].func,
    onKeyPress: _propTypes["default"].func,
    onClickReset: _propTypes["default"].func,
    onKeyPressReset: _propTypes["default"].func
  }).isRequired,
  fieldData: _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    fieldKey: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    options: _propTypes["default"].array.isRequired,
    validation: _propTypes["default"].shape({
      message: _propTypes["default"].string.isRequired,
      pattern: _propTypes["default"].number.isRequired
    }).isRequired,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]).isRequired
  }).isRequired
};

var _default = (0, _index["default"])(RankInput, _validator["default"], _EventHandler["default"]);

exports["default"] = _default;